import { ServiceState } from './index';
import { MutationTree } from 'vuex';
import { ServiceAmount } from "@store/checkout/interfaces/serviceItem";
import { ServiceGroups } from "@store/checkout/interfaces/serviceGroups";

export default {
    setAvailableServices(state, serviceGroups: ServiceGroups) {
        state.availableServices = serviceGroups;
    },
    addSelectedServices(state, { service, serviceType }) {
        const selectedService: ServiceAmount | undefined = state.selectedServices[serviceType].find((selected: ServiceAmount) => selected.id === service.id);

        if (selectedService !== undefined) {
            selectedService.amount++
        } else {
            state.selectedServices[serviceType].push({
                ...service,
                amount: 1
            });
        }
    },
    restoreSelectedServices(state, { service, serviceType, amount }) {
        state.selectedServices[serviceType].push({
            ...service,
            amount: amount
        });
    },
    reduceSelectedServices(state, { service, serviceType }) {
        const selectedService: ServiceAmount | undefined = state.selectedServices[serviceType].find((selected: ServiceAmount) => selected.id === service.id);

        if (selectedService === undefined) {
            return;
        }

        selectedService.amount--;
        if (selectedService.amount === 0) {
            state.selectedServices[serviceType].forEach((serviceItem: ServiceAmount, index: number) => {
                if (serviceItem.id === selectedService.id) {
                    state.selectedServices[serviceType].splice(index, 1);
                }
            });
        }
    }
} as MutationTree<ServiceState>
